import React, { useContext, useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { Typography, CircularProgress } from "@mui/material";
import { userOnboardingContext } from "../../states/context/userOnboardingContext";
import { onboardingUserDetails } from "../../userOnboardingConstants";
import { useNavigate } from "react-router-dom";
import agentMask from "../../assets/images/userOnboarding/agentMask.png";
import kavidaLogo from "../../assets/images/userOnboarding/kavidaLogo.png";

const OnboardingContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100%",
  backgroundColor: "#F7F7F7",
}));

const OnboardingLeft = styled('div')(({ theme }) => ({
  flex: 2,
}));

const OnboardingTitle = styled(Typography)(({ theme }) => ({
  color: "#171717",
  marginBottom: "24px",
  fontFamily: "Figtree",
  fontSize: "32px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal",
}));

const OnboardingText = styled(Typography)(({ theme }) => ({
  marginBottom: "89px",
  color: "#747474",
  fontFamily: "Figtree",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
}));

const DidYouKnow = styled('div')(({ theme }) => ({
  backgroundColor: "#FFF",
  flexDirection: "column",
  padding: "20px 24px",
  borderRadius: "8px",
  display: "flex",
  boxShadow: "-4px 8px 16px 0px rgba(23, 23, 23, 0.08)",
  position: "relative",
  maxWidth: "65%",
}));

const DidYouKnowArrow = styled('div')(({ theme }) => ({
  position: "absolute",
  bottom: "-15px",
  left: "24px",
  width: "0",
  height: "0",
  borderLeft: "15px solid transparent",
  borderRight: "15px solid transparent",
  borderTop: "15px solid #FFF",
}));

const DidYouKnowTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Figtree",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal",
  marginBottom: "8px",
}));

const DidYouKnowText = styled(Typography)(({ theme }) => ({
  color: "#747474",
  fontFamily: "Figtree",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
}));

const LoaderContainer = styled('div')(({ theme }) => ({
  margin: "64px 0 24px 0",
  display: 'flex',
  height: '100%',
}));

const OnboardingLeftContent = styled('div')(({ theme }) => ({
  padding: "0 48px 0 85px",
}));

const BuildAIAgentprogress = () => {
  const userContext = useContext(userOnboardingContext);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/onboarding/automation");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  console.log(userContext, onboardingUserDetails);

  return (
    <OnboardingContainer>
      <OnboardingLeft>
        <OnboardingLeftContent>
          <img src={kavidaLogo} alt="KavidaLogo" width={117} height={24} />
          <LoaderContainer>
            <CircularProgress style={{ color: "#6933FF" }} size={48} />
          </LoaderContainer>
          <OnboardingTitle variant="h1">
            Hold on, we are building your personalized AI agent to provide a seamless experience
          </OnboardingTitle>
          <OnboardingText variant="body1">
            We're working behind the scenes to ensure your experience is smooth, efficient, and tailored to your needs. Please bear with us while we finalize everything.
          </OnboardingText>
          <DidYouKnow>
            <DidYouKnowTitle>Did you know?</DidYouKnowTitle>
            <DidYouKnowText>
              You can ask me about anything about risks associated with your suppliers
            </DidYouKnowText>
            <DidYouKnowArrow></DidYouKnowArrow>
          </DidYouKnow>
          <img src={agentMask} alt="AI Agent Icon" width={72} height={72} style={{ marginTop: '40px' }} />
        </OnboardingLeftContent>
      </OnboardingLeft>
    </OnboardingContainer>
  );
};

export default BuildAIAgentprogress;
